<div *ngIf="!collapse || showFull">
  <ul class="no-bullet" *ngFor="let stock of locationStocks">
    <li class="warehouse" *ngIf="stock.warehouse">
      {{ stock.warehouse.locationName }}
    </li>
    <li *ngFor="let location of stock.stockLocations">
      <cnc-picklist-location
        [pickingLocation]="location.isPickLocation"
      ></cnc-picklist-location>
      <a
        [routerLink]="'/locations/s/' + location.id + '/details'"
        [queryParams]="{ sku: rfq?.internalSku }"
        routerLinkActive="router-link-active"
        >{{ location.locationName }}</a
      >
      {{ location?.pivot?.onhandQuantity | decimalPlaces }}
    </li>
  </ul>
</div>
<div *ngIf="collapse && !showFull && locations.length > 0">
  <ul class="no-bullet">
    <li *ngFor="let location of locations">
      <cnc-picklist-location
        [pickingLocation]="location.isPickLocation"
      ></cnc-picklist-location>
      <a
        [routerLink]="'/locations/s/' + location.id + '/details'"
        [queryParams]="{ sku: rfq?.internalSku }"
        routerLinkActive="router-link-active"
        >{{ location.locationName }}</a
      >
      {{ location?.pivot?.onhandQuantity | decimalPlaces }}
    </li>
  </ul>
</div>
<div class="action" *ngIf="collapse && locations.length > 0">
  <small class="d-inline-block mt-1 text-cloud-600 text-nowrap">
    [
    <button
      type="button"
      class="linkish show-more"
      (click)="showFull = !showFull"
      >{{ showFull ? 'show less' : 'show more' }}</button
    >
    ]
  </small>
</div>
